import gql from "graphql-tag";

export const MY_TAX_DECLARATIONS_SUBSCRIPTION = gql`
  subscription taxDecalartionsSubscription {
    taxDecalartionsSubscription
  }
`;
